export default [
    {
        text: 'MobileApps',
        value: 'automations',
        icon: 'mdi-cellphone-cog' ,
        module : 'mobileapps',
        permission:'MODULE_MOBILEAPPS',
        id :'mobileapps',
        owner : true,
        children : [
            // {
            //     text: 'mobileapps.descriptions.title',
            //     value: 'mobileapps/description',
            //     path: 'mobileapps/description',
            //     module : 'mobileapps',
            // },
            {
                text: 'MobileFeed',
                value: 'mobileapps/news',
                path: 'mobileapps/news',
                module : 'mobileapps',
            },
            {
                text: 'Statistics',
                value: 'mobileapps/statistics',
                path: 'mobileapps/statistics',
                module : 'mobileapps',
            },
            {
                text: 'InAppPurchases',
                value: 'mobileapps/iap',
                path: 'mobileapps/iap',
                module : 'mobileapps',
            },
            {
                text: 'Settings',
                value: 'mobileapps/settings',
                path: 'mobileapps/settings',
                module : 'mobileapps',
            }
        ],
    },
]